import { useRef } from "react";
import { useTranslation } from "next-i18next";
import { useExtendedSearchDownloadMutation } from "src/api/client/extended-search.api";
import { Button, ButtonProps } from "src/components/base/button/button";
import { IconDownload } from "src/components/icons";
import { EnumToastStatus, useWfToast } from "src/hooks/use-wf-toast";
import { useRouterLocale } from "src/utils/router/use-router-locale";
import { searchStore } from "../../store/search-store";
import { getMappedStore } from "../../store/utils";

export interface IDownloadButton extends ButtonProps {
    userNumOfDownloads: number;
}

export const DownloadButton = ({ userNumOfDownloads }: IDownloadButton) => {
    const downloads = useRef(userNumOfDownloads);
    const toastVisible = useRef(false);
    const toast = useWfToast();
    const { t } = useTranslation(["extended-search", "common"]);
    const searchMutation = useExtendedSearchDownloadMutation();
    const { country } = useRouterLocale();

    const onError = (title: string) => {
        if (!toastVisible.current) {
            toastVisible.current = true;
            toast({ status: EnumToastStatus.Error, duration: 5000, title: title });
            setTimeout(() => {
                toastVisible.current = false;
            }, 5000);
        }
    };

    const onDownloadClick = async () => {
        if (downloads.current < 5) {
            try {
                await searchMutation({
                    country,
                    ...getMappedStore(searchStore),
                });
                downloads.current++;
            } catch (error) {
                onError(t("general-error", { ns: "common" }));
            }
        } else {
            onError(t("download-limit-reached"));
        }
    };

    return (
        <Button
            display={["none", "none", "flex"]}
            onClick={onDownloadClick}
            height={4}
            ml="auto"
            fontSize="sm"
            variant="ghost"
            alignSelf="center"
            leftIcon={<IconDownload boxSize={3} mb={0.5} />}
        >
            {t("buttons.download")}
        </Button>
    );
};
